function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 6,
  fill: "#B00"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.031 10H11.14A5.137 5.137 0 006 15.142v9.136a5.138 5.138 0 005.139 5.142H28.03a5.138 5.138 0 005.139-5.142v-9.136A5.139 5.139 0 0028.03 10zM16.005 23.874v-8.328l7.16 4.164-7.16 4.164z",
  fill: "#fff"
});

function SvgSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgSocialYoutube;